import { notification } from "antd";
import { color } from "./themes/color";
import Axios from './api/axiosConf';
import { url } from './api/api';





export const GreenNotif = (text) => {
    notification.open({
        message: "موفقیت",
        description: text,
        style: {
            background: color.secondary,
            color: "white",
            fontFamily: "iranSans",
            fontSize: "25px",
            borderRadius: "5px",
        }
    })
}

export const RedNotif = (text) => {
    notification.error({
        message: "اخطار",
        description: text,
        style: {
            background: color.error,
            color: "white ",
            fontSize: "25px",
            fontFamily: "iranSans",
            borderRadius: "5px",
        }
    })
}

export const FarsiDate = (date, type) => {
    if (type) {
        switch (type) {
            // case "number": return (new Date(date).toLocaleString("fa-IR", { year: "numeric", month: "2-digit", day: "2-digit" }))
            default: return (new Date(date).toLocaleString("fa-IR", { year: "numeric", month: "2-digit", day: "2-digit" }))
        }
    } else {
        return (new Date(date).toLocaleString("fa-IR", { year: "numeric", month: "2-digit", day: "2-digit" }))
    }

}

export const Uploder = async (file, type) => {
    var data = new FormData();
    var res
    data.append('file', file);
    data.append('type', type)
    await Axios.post(`${url}files/v1/upload`, data)
        .then((response) => {
            res = response
        })
        .catch((error) => {
            console.log("3", error)
            res = error
        });

    return res
}

